import React, { useCallback, useEffect, useState } from "react";
import Header from "../layout/Header";
import { formatDatee, formatZuluTime } from "../../helpers/converter";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getApplications } from "../../actions/application/getApplications";
import { pagingApplicationNurse } from "../../actions/nurse/pagingApplicationNurse";
import Swal from "sweetalert2";
import {
  completeNurseAssesment,
  resetCompleteNurseAssesment
} from "../../actions/nurse/completeNurseAssesment";
import Stepper from "../helpers/Stepper";
import { Input, Pagination, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "lodash";

function Dashboard(props) {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(11);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState(""); // Yeni eklenen searchText state'i

  const totalCount =
    props.pagingApplicationNurse.pagingApplicationNurse?.result.totalCount; // Sonuç modelinden gelen toplam kayıt sayısı
  const pageCount = Math.ceil(totalCount / pageSize);

  useEffect(() => {
    dispatch(pagingApplicationNurse(pageSize, page, status));
  }, [dispatch, status]);

  useEffect(() => {
    // Burada, sayfa değiştiğinde verileri yeniden yükleme işlevini tetikle
    dispatch(pagingApplicationNurse(pageSize, page, status));
  }, [page, pageSize, dispatch]);

  // Debounce fonksiyonunu oluşturun
  const debouncedSearch = useCallback(
    debounce((searchText) => {
      if (searchText.length >= 3 || searchText.length === 0) {
        dispatch(pagingApplicationNurse(pageSize, page, status, searchText));
      }
    }, 500), // 500ms bekleme süresi
    [pageSize, page, status, dispatch] // searchText'i buradan kaldırın
  );

  // searchText değiştiğinde debouncedSearch fonksiyonunu çağırın
  useEffect(() => {
    debouncedSearch(searchText);

    // Temizleme işlemi
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchText, debouncedSearch]);

  // Sayfa veya sayfa boyutu değiştiğinde API isteği gönderin
  useEffect(() => {
    dispatch(pagingApplicationNurse(pageSize, page, status, searchText));
  }, [page, pageSize, status, dispatch]);

  const handlePaginationChange = (currentPage, pageSize) => {
    setPage(currentPage - 1);
    setPageSize(pageSize);
  };

  useEffect(() => {
    if (props.completeNurseAssesment.done) {
      Swal.fire({
        icon: "success",
        title: "Başvuru doktor onayına gönderildi!",
        showConfirmButton: false,
        timer: 1500
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        dispatch(resetCompleteNurseAssesment());
        dispatch(pagingApplicationNurse(pageSize, page, status, searchText));
      });
    }
  }, [props.completeNurseAssesment]);

  console.log(props.pagingApplications?.pagingApplications);

  return (
    <div>
      <Header />
      <div className="pt-10 md:ml-64 ps-5">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="order-2 md:order-1">
            <ol
              className="items-center whitespace-nowrap min-w-0 text-left"
              aria-label="Breadcrumb"
            >
              <li
                className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
                aria-current="page"
              >
                Atanan başvurular
              </li>
            </ol>
          </div>
          <div
            className="order-1 md:order-2 relative mb-5 md:mb-0 md:float-right md:mr-5"
            style={{ marginRight: "5px" }}
          >
            <div className="flex space-x-2">
              <div>
                <Input
                  type="text"
                  placeholder="Başvuru Arama..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  suffix={<SearchOutlined />}
                />
              </div>
              <div>
                <select
                  defaultValue={11}
                  onChange={(e) => {
                    dispatch(
                      pagingApplicationNurse(pageSize, page, e.target.value)
                    );
                    setStatus(e.target.value);
                  }}
                  id="select-1"
                  className="py-2 px-3 pe-16 block w-full border-gray-500 rounded-lg text-sm focus:border-gray-500 focus:ring-gray-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                >
                  <option value={11}>Tıbbi sekreterlik onayında olanlar</option>
                  <option value={10}>Doktor onayı bekleyenler</option>
                  <option value={3}>Doktor tarafından reddedilenler</option>
                  <option value={6}>Sonuçlananlar</option>
                  <option value={2}>Doktor tarafından kabulu yapılanlar</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.pagingApplicationNurse.pagingApplicationNurse?.result
        .totalCount === 0 ? (
        <div className="flex justify-center items-center mt-20 font-bold text-xl">
          <h1>Görüntülenecek başvurunuz bulunmamaktadır</h1>
        </div>
      ) : (
        <div>
          <hr className="divide-y mt-2" />
          <p className="mt-5 ps-5 md:ml-64 text-md text-gray-500 text-start mb-">
            Başvurunuzun detaylarını görüntülemek için üzerine tıklayın.
          </p>
          <div className="mb-5">
            {props.pagingApplicationNurse.done ? (
              <div className="mt-5 ps-5 md:ml-64 pe-5">
                {props.pagingApplicationNurse.pagingApplicationNurse?.result?.entities.map(
                  (element, index) => {
                    return (
                      <div
                        key={index}
                        className="bg-slate-100 border rounded-sm text-start mb-3"
                      >
                        <div className="top-0 left-0 right-0">
                          <div className="p-4 md:p-5">
                            <div className="flex justify-between">
                              <Link
                                to={`/application-detial-doctor/${element.id}`}
                                className="text-xl font-semibold flex flex-row items-center"
                              >
                                {element.applicationTargetInstitutionType ===
                                0 ? (
                                  <div className="hs-tooltip [--placement:right]">
                                    <img
                                      className="mr-4 hs-tooltip-toggle"
                                      src="/assets/images/facilities/hacettepegucuklogo.png"
                                      width={35}
                                      alt=""
                                    />
                                    <span
                                      className=" hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                      role="tooltip"
                                    >
                                      Hacettepe Üniversitesi Hastahaneleri
                                    </span>
                                  </div>
                                ) : element.applicationTargetInstitutionType ===
                                  1 ? (
                                  <div className="hs-tooltip [--placement:right]">
                                    <img
                                      className="mr-2 hs-tooltip-toggle"
                                      src="/assets/images/facilities/erciyesuni.png"
                                      width={75}
                                      style={{ paddingRight: "5px" }}
                                      alt=""
                                    />
                                    <span
                                      className=" hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                      role="tooltip"
                                    >
                                      Erciyes Üniversitesi Tıp Fakültesi
                                    </span>
                                  </div>
                                ) : null}
                                {element.assignments[0].professionName}

                                {element.applicationStatus === 11 ? (
                                  <div class="hs-tooltip inline-block">
                                    <Link
                                      to={`/edit-care-provider/${element.id}/${element.applicationTargetInstitutionType}`}
                                      className="ml-3"
                                    >
                                      <i className="fa-regular fa-pen-to-square hs-tooltip-toggle"></i>
                                      <span
                                        class="hs-tooltip-content hs-tooltip-shown:opacity-100 text-xs hs-tooltip-shown:visible transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-white"
                                        role="tooltip"
                                      >
                                        Bölüm / Doktor Değiştir
                                      </span>
                                    </Link>
                                  </div>
                                ) : null}
                                <Link
                                  to={`/application-detial-doctor/${element.id}`}
                                  class="ml-4 text-sm text-blue-600 underline decoration-gray-800 hover:opacity-80 dark:decoration-white"
                                  href="#"
                                >
                                  Başvuru detayı{" "}
                                  <i class="fa-sharp fa-light fa-arrow-right ml-2"></i>
                                </Link>
                              </Link>

                              <div>
                                <p className="mt-1 text-xs text-gray-500">
                                  {formatZuluTime(element.createdAt)}
                                </p>
                                <br />
                              </div>
                              <br />
                            </div>
                            <div className="flex justify-between">
                              <p
                                className={`mt-3 text-sm mb-3  ${
                                  element.applicationStatus === 3
                                    ? `text-red-600`
                                    : `onedose-color`
                                }`}
                              >
                                <div>
                                  {" "}
                                  <b style={{ color: "black" }}>
                                    Doktor Adı Soyadı :{" "}
                                  </b>{" "}
                                  {element.assignments[0].doctor.name +
                                    " " +
                                    element.assignments[0].doctor.lastName}
                                </div>
                                <b style={{ color: "black" }}>
                                  Başvuru Durumu :{" "}
                                </b>
                                {element.applicationStatus === 0
                                  ? "Başvuru bekleniyor"
                                  : element.applicationStatus === 10
                                  ? "Doktor onayı bekleniyor"
                                  : element.applicationStatus === 3
                                  ? "Reddedildi"
                                  : element.applicationStatus === 11
                                  ? "Tıbbi sekreterlik onayında"
                                  : element.applicationStatus === 6
                                  ? "Başvuru sonuçlandırıldı"
                                  : element.applicationStatus === 2
                                  ? "Doktor kabulü yapıldı"
                                  : null}
                              </p>
                              {/* <button type="button" className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                                                Başvuru bölüm ve hekim değiştir
                                            </button> */}
                            </div>
                            <Stepper stateHistory={element.stateHistory} />
                            <div className="grid md:flex gap-20">
                              <div>
                                {element.applicationRepresentedPerson ? (
                                  <>
                                    <h3 className="font-semibold text-lg">
                                      Hasta Bilgileri
                                    </h3>
                                    <p>
                                      <b>Hasta Adı: </b>
                                      {element.applicationRepresentedPerson
                                        ? element.applicationRepresentedPerson
                                            .name +
                                          " " +
                                          element.applicationRepresentedPerson
                                            .surname
                                        : "Bilgi eksik"}
                                    </p>
                                    <p>
                                      <b>Hasta Kimlik Bilgisi: </b>
                                      {element.applicationRepresentedPerson
                                        ? element.applicationRepresentedPerson
                                            .nationalIdentifier
                                        : "Bilgi eksik"}
                                    </p>
                                    <p>
                                      <b>Doğum Tarihi: </b>
                                      {element.applicationRepresentedPerson
                                        ? `${String(
                                            element.applicationRepresentedPerson
                                              .birthDateDay
                                          ).padStart(2, "0")}/${String(
                                            element.applicationRepresentedPerson
                                              .birtDateMonth
                                          ).padStart(2, "0")}/${
                                            element.applicationRepresentedPerson
                                              .birthDateYear
                                          }`
                                        : "Bilgi eksik"}
                                    </p>

                                    <p>
                                      <b>Cinsiyet: </b>
                                      {element.applicationRepresentedPerson
                                        ? element.applicationRepresentedPerson
                                            .gender === 2
                                          ? "Kadın"
                                          : "Erkek"
                                        : "Bilgi eksik"}
                                    </p>
                                  </>
                                ) : (
                                  <div>
                                    <h3 className="font-semibold text-lg">
                                      Hasta Bilgileri
                                    </h3>
                                    <p>
                                      <b>Hasta Adı: </b>
                                      {element.applicationOwnerUser.name +
                                        " " +
                                        element.applicationOwnerUser.lastName}
                                    </p>
                                    <p>
                                      <b>Hasta Kimlik Bilgisi: </b>
                                      {element.applicationOwnerUser
                                        .nationalId || "Bilgi eksik"}
                                    </p>
                                    <p>
                                      <b>Hasta E-posta </b>
                                      {element.applicationOwnerUser.email ||
                                        "Bilgi eksik"}
                                    </p>
                                    <p>
                                      <b>Hasta Telefon Numarası: </b>
                                      {element.applicationOwnerUser
                                        .phoneNumber || "Bilgi eksik"}
                                    </p>
                                  </div>
                                )}
                              </div>

                              {element.applicationRepresentedPerson ? (
                                <div>
                                  <h3 className="font-semibold text-lg">
                                    Başvuran Bilgileri
                                  </h3>
                                  <p>
                                    <b>Başvuran Adı: </b>
                                    {element.applicationOwnerUser.name +
                                      " " +
                                      element.applicationOwnerUser.lastName}
                                  </p>
                                  <p>
                                    <b>Başvuran Kimlik Bilgisi: </b>
                                    {element.applicationOwnerUser.nationalId ||
                                      "Bilgi eksik"}
                                  </p>
                                  <p>
                                    <b>Başvuran E-Posta: </b>
                                    {element.applicationOwnerUser.email ||
                                      "Bilgi eksik"}
                                  </p>
                                  <p>
                                    <b>Başvuran Telefon Numarası: </b>
                                    {element.applicationOwnerUser.phoneNumber ||
                                      "Bilgi eksik"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            {element?.applicationStatus === 11 ? (
                              <button
                                type="button"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Emin misiniz?",
                                    text: "Bu işlem geri alınamaz! Başvuruyu doktor onayına göndermek istediğinize emin misiniz?",
                                    confirmButtonColor: "#09C35C",
                                    showCancelButton: true,
                                    cancelButtonText: `Hayır`,
                                    confirmButtonText: `Evet`
                                  }).then((result) => {
                                    dispatch(
                                      completeNurseAssesment(element.id)
                                    );
                                  });
                                }}
                                style={{ backgroundColor: "#09C35C" }}
                                className="mt-3 py-3 px-4 inline-flex text-white items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-500 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                              >
                                <i class="fa-solid fa-badge-check"></i>
                                Başvuruyu doktor onayına gönder
                              </button>
                            ) : null}
                            <div className="hs-tooltip">
                              <button
                                className={`${
                                  element.applicationStatus === 11
                                    ? "opacity-50 pointer-events-none hs-tooltip-toggle"
                                    : ""
                                }`}
                              >
                                <Link
                                  disabled={element.applicationStatus === 11}
                                  to={`/note-detail/${element.id}/${
                                    element.applicationRepresentedPerson
                                      ? element.applicationRepresentedPerson
                                          .name +
                                        " " +
                                        element.applicationRepresentedPerson
                                          .surname
                                      : element.applicationOwnerUser.name +
                                        " " +
                                        element.applicationOwnerUser.lastName
                                  }`}
                                  className=" mt-3 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                                >
                                  <i className="fa-thin fa-user-doctor-message"></i>{" "}
                                  Başvuruya ilişkin notlar
                                </Link>
                                <span
                                  className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700 -left-full translate-x-2"
                                  role="tooltip"
                                >
                                  Başvuru durumu "Tıbbi sekreterlik onayında"
                                  olduğu için not ekleyemezsiniz.
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            ) : null}
            {props.pagingApplicationNurse.spinner ? (
              <div className="relative mt-5 ps-5 pe-5 md:ml-64">
                <div className="bg-yellow-50 border border-red-200 rounded-md p-4">
                  <div className="flex">
                    <div className="ml-3 text-start">
                      <h3 className="text-sm text-red-800 font-medium">
                        Detaylar Yükleniyor
                      </h3>
                      <div className="text-sm text-red-700 mt-2">
                        <span className="font-semibold">Lütfen bekleyin!</span>{" "}
                        Başvuru detaylarınız getiriliyor.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <div
                    className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-red-600 rounded-full"
                    role="status"
                    aria-label="loading"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <nav className="flex items-center gap-x-1 pt-10 md:ml-64 ps-5 float-right me-5">
            <Pagination
              current={page + 1}
              pageSize={pageSize}
              total={totalCount}
              onChange={handlePaginationChange}
              showSizeChanger
              pageSizeOptions={["5", "10", "20", "50"]}
            />
          </nav>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(Dashboard);
